module.exports = __webpack_public_path__ + "static/media/carp_mobile_messenger.f9528249.gif";